import { Award, Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/i18n";

const Footer = ({ t }) => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#060d18] text-white border-t border-[#d4af37]/20"
    >
      <div className="bid-container py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/bid-logo.jpg"
                alt="BID"
                className="h-12 w-12 object-contain"
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <div>
                <div className="font-display font-black text-xl text-white">
                  BID<span className="text-[#d4af37]">.</span> Soluções Integradas
                </div>
                <div className="bid-overline text-[10px] text-[#d4af37]">
                  {CONTACT.domain}
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-white/70 leading-relaxed max-w-md">
              {t.footer.description}
            </p>
            <p className="mt-6 font-display italic text-[#d4af37] text-sm">
              "{t.footer.slogan}"
            </p>

            {/* Quality Seal */}
            <div
              className="mt-8 inline-flex items-center gap-3 border border-[#d4af37]/40 px-4 py-3"
              data-testid="quality-seal"
            >
              <Award className="w-5 h-5 text-[#d4af37]" />
              <div>
                <div className="bid-overline text-[10px] text-[#d4af37]">BID Seal</div>
                <div className="text-xs font-bold text-white">{t.footer.seal}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="bid-overline text-[#d4af37] text-xs mb-5">
              {t.footer.sections.services}
            </h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="#services" className="hover:text-[#d4af37] transition-colors">NR10 — Consultoria & Meio Ambiente</a></li>
              <li><a href="#services" className="hover:text-[#d4af37] transition-colors">NR33 — Segurança em Altura</a></li>
              <li><a href="#services" className="hover:text-[#d4af37] transition-colors">NR35 — Segurança de Máquinas</a></li>
              <li><a href="#portfolio" className="hover:text-[#d4af37] transition-colors">Manutenção Industrial</a></li>
              <li><a href="#portfolio" className="hover:text-[#d4af37] transition-colors">Jateamento & Pintura</a></li>
              <li><a href="#portfolio" className="hover:text-[#d4af37] transition-colors">Tubulações</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="bid-overline text-[#d4af37] text-xs mb-5">
              {t.footer.sections.contact}
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3 items-start">
                <Phone className="w-4 h-4 text-[#d4af37] mt-0.5 flex-shrink-0" />
                <div className="flex flex-col gap-0.5">
                  <a
                    href={`https://wa.me/${CONTACT.whatsappRaw}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/90 hover:text-[#d4af37] transition-colors"
                  >
                    {CONTACT.whatsappDisplay}
                  </a>
                  <a
                    href={`https://wa.me/${CONTACT.whatsappSecondaryRaw}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-white/60 hover:text-[#d4af37] transition-colors"
                  >
                    {CONTACT.whatsappSecondaryDisplay}
                  </a>
                </div>
              </li>
              <li className="flex gap-3 items-start">
                <Mail className="w-4 h-4 text-[#d4af37] mt-0.5 flex-shrink-0" />
                <div className="flex flex-col gap-3 min-w-0">
                   {CONTACT.emails.map((item, idx) => (
                      <div key={idx} className="flex flex-col gap-0.5">
                        <span className="text-[10px] font-bold text-white/40 uppercase tracking-wider">{item.label}</span>
                        <a
                          href={`mailto:${item.address}`}
                          className="text-sm text-white/90 hover:text-[#d4af37] transition-colors break-all"
                        >
                          {item.address}
                        </a>
                      </div>
                    ))}
                </div>
              </li>
              <li className="flex gap-3 items-start">
                <MapPin className="w-4 h-4 text-[#d4af37] mt-0.5 flex-shrink-0" />
                <span className="text-white/80 leading-relaxed">{CONTACT.address}</span>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10 text-xs text-white/60 leading-relaxed">
              <div className="text-white/80 font-bold">{CONTACT.contactPerson}</div>
              <div className="text-white/60 mb-2">{CONTACT.contactRole}</div>
              <div className="text-white/80 font-bold">{CONTACT.contactPerson2}</div>
              <div className="text-white/60">{CONTACT.contactRole2}</div>
              <div className="mt-3">{CONTACT.legalName}</div>
              <div>CNPJ {CONTACT.cnpj}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="bid-container py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {year} BID Soluções Integradas. {t.footer.rights}</p>
          <p className="font-display tracking-widest uppercase">{CONTACT.domain}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
